/*
 app dependencies
 - var body

 lib dependencies
*/

const scLoginInfoForm = (function($)
{
    //public
    //private
    const   _changePasswordField = document.querySelector('input.js-change-password'),
            _passwordWrap = document.querySelector('.js-password-wrap'),
            _passwordField = document.querySelector('input.js-password-field'),
            _passwordConfirmField = document.querySelector('input.js-password-confirm-field');

	//module functions
	function init()
	{
        if (!_changePasswordField || !_passwordWrap) return;

        console.log(_passwordConfirmField);

        _changePasswordField.addEventListener('change', function(e)
        {
            if (this.checked)
            {
                console.log('validate!');
                _passwordWrap.classList.add('password-wrap--visible');
                _passwordField.classList.add('validate-me');
                _passwordConfirmField.classList.add('validate-me');
            }
            else
            {
                _passwordWrap.classList.remove('password-wrap--visible');
                _passwordField.classList.remove('validate-me');
                _passwordConfirmField.classList.remove('validate-me');
            }
        });
	}


	//reveal public vars and functions
	return {
		//vars

		//functions
		init
	};

})(jQuery);
